export enum StatementType {
  summary = 'Summary',
  detailed = 'Detailed',
}
